import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from './App';
import './Navbar.css';
import Cookies from 'js-cookie';

const LOGO_URL =
  'https://gfgfgfgghvfgcbjhyuvojikn.s3.eu-central-1.amazonaws.com/m.svg';

const Navbar = () => {
  const { user, setUser, isLogged, setIsLogged } = useContext(AppContext);
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogout = () => {
    setUser(null);
    setIsLogged(false);
    Cookies.remove('user');
    Cookies.remove('isLogged');
    navigate('/');
  };

  const toggleMenu = () => setIsMenuOpen((v) => !v);
  const closeMenu = () => setIsMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar__inner">
        {/* Logo on the LEFT */}
        <Link to="/" className="navbar__logo" onClick={closeMenu} aria-label="Mariage Home">
          <img src={LOGO_URL} alt="Mariage" />
        </Link>

        {/* Mobile button (we keep it; desktop CSS hides it) */}
        <button className="menu-button" onClick={toggleMenu} aria-label="Open menu">
          ☰
        </button>

        {/* Menu pills on the RIGHT */}
        <ul className={`nav-links ${isMenuOpen ? 'open' : ''}`}>
          {isLogged ? (
            <>
              <li><Link to="/personal_info" onClick={closeMenu}>אזור אישי</Link></li>
              <li><Link to="/expenses" onClick={closeMenu}>ניהול הוצאות</Link></li>
              <li><Link to="/tables" onClick={closeMenu}>סידור שולחנות</Link></li>
              <li><Link to="/add-invites" onClick={closeMenu}>הוספת מוזמנים</Link></li>
              <li><Link to="/my-invites" onClick={closeMenu}>המוזמנים שלי</Link></li>

              <li className="nav-hello">
                שלום {user ? user.user.username : 'משתמש'} /
                <button
                  type="button"
                  className="nav-logout"
                  onClick={() => {
                    closeMenu();
                    handleLogout();
                  }}
                >
                  התנתק
                </button>
              </li>
            </>
          ) : (
            <>
              <li><Link to="/" onClick={closeMenu}>דף הבית</Link></li>
              <li><Link to="/#packages" onClick={closeMenu}>המסלולים שלנו</Link></li>
              <li><Link to="/login" onClick={closeMenu}>אזור אישי</Link></li>
              <li><Link to="/#contact" onClick={closeMenu}>צור קשר</Link></li>
            </>
          )}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
